import React, { FC } from 'react';
import { Control } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ChevronDownIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../components/combobox/index';
import { ShareClass as ShareClassHook } from '../../../hooks/index';
import { ShareClass } from '../../../types/share-classes.types';
import { FormSchema } from './pool-form.validation';

export type ShareClassesItemsListProps = {
  control: Control<FormSchema>;
  data: ShareClass[];
  isLoading: boolean;
};

const ShareClassesItemsList: FC<ShareClassesItemsListProps> = ({ data, control, isLoading }) => {
  const navigate = useNavigate();
  if (!data || isLoading)
    return (
      <span>
        <AppFormattedMessage id="LOADING" />
      </span>
    );
  return (
    <>
      {data.map(({ name, id }, i) => (
        <FormComboboxOption
          control={control}
          key={`${name}_${i}`}
          name="stepOne.shareClass"
          value={{ id, name }}
        >
          <span className="text-sm text-gray-700">{name}</span>
        </FormComboboxOption>
      ))}
      <Button
        className="h-[37px] w-full justify-start rounded bg-brand-25 px-[6px] text-start text-sm font-[450] text-brand-700"
        onClick={() => navigate('/share-classes?openAddModal=true')}
        styleType="NONE"
      >
        + <AppFormattedMessage id="ADD_NEW_SHARE_CLASS" />
      </Button>
    </>
  );
};

export type ShareClassComboboxProps = {
  companyId: string;
  control: Control<FormSchema>;
};

export const ShareClassCombobox: FC<ShareClassComboboxProps> = ({ control, companyId }) => {
  const { shareClasses, isLoading } = ShareClassHook.useShareClasses({ companyId, filter: 'all' });

  return (
    <FormCombobox className="relative" control={control} name={'stepOne.shareClass'}>
      <div className="relative">
        <FormComboboxInput
          className={'bg-gray-900'}
          control={control}
          customValue={(value) => value?.name}
          icon={<ChevronDownIcon className="mt-2" />}
          name={'stepOne.shareClass'}
          placeholder={<AppFormattedMessage id="SELECT_SHARE_CLASS" />}
          readOnly
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="w-full">
        <ShareClassesItemsList control={control} data={shareClasses || []} isLoading={isLoading} />
      </ComboboxOptions>
    </FormCombobox>
  );
};
